export const getRepoItemSource = (item) => {
  if (item?.isPersonalSpace) return "personal_space";
  return item?.itemSource || "trained_document";
};

export const getRepoItemBackendId = (item) => {
  if (item?.isPersonalSpace) {
    return item?.originalId ?? null;
  }

  return item?.backendId ?? item?.originalId ?? item?.uploaded_file_id ?? null;
};

export const getRepoMovePayloadItem = (item) => {
  const itemSource = getRepoItemSource(item);
  const backendId = getRepoItemBackendId(item);

  if (!backendId) {
    return null;
  }

  if (itemSource === "trained_document") {
    return {
      type: item.type,
      id: backendId,
    };
  }

  if (itemSource === "uploaded_file") {
    return {
      type: "uploaded",
      id: backendId,
    };
  }

  return null;
};
